import AppointChart from "./AppointChart";
import AppointType from "./AppointType";
import TimeSlotHeatmap from "./TimeSlotHeatmap";



function App() {
  return (
    <div className="App">
       <div style={{ padding: '30px', background: '#f8f9fb' }}>
        <AppointChart/>
        <AppointType/>
        <TimeSlotHeatmap/>
            </div>


          
    </div>
  );
}

export default App;
